/* Sielo — comportements front (aucune dépendance externe) */
(function () {
  'use strict';

  var routes = (window.Sielo && window.Sielo.routes) || {};

  /* ---------- Utilitaires ---------- */
  function on(root, evt, sel, fn) {
    root.addEventListener(evt, function (e) {
      var el = e.target.closest(sel);
      if (el && root.contains(el)) fn(e, el);
    });
  }
  function money(cents) {
    var fmt = (window.Sielo && window.Sielo.moneyFormat) || '{{amount_with_comma_separator}} €';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return fmt
      .replace('{{amount_with_comma_separator}}', intPart + ',' + parts[1])
      .replace('{{amount}}', intPart + '.' + parts[1])
      .replace('{{amount_no_decimals}}', intPart);
  }

  /* ---------- Menu mobile ---------- */
  on(document, 'click', '[data-menu-toggle]', function (e, el) {
    var nav = document.getElementById(el.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- Compte à rebours ---------- */
  var countdownTimer = null;
  function startCountdowns() {
    var nodes = document.querySelectorAll('[data-countdown]');
    if (!nodes.length) return;
    if (countdownTimer) clearInterval(countdownTimer);
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = Date.now();
      nodes.forEach(function (node) {
        var hours = parseFloat(node.getAttribute('data-countdown')) || 24;
        var key = 'sielo-countdown-' + (node.getAttribute('data-countdown-id') || 'default');
        var end = 0;
        try { end = parseInt(window.localStorage.getItem(key) || '0', 10); } catch (err) {}
        if (!end || end < now) {
          end = now + hours * 3600e3;
          try { window.localStorage.setItem(key, String(end)); } catch (err) {}
        }
        var s = Math.max(0, Math.floor((end - now) / 1000));
        if (node.getAttribute('data-countdown-format') === 'hms') {
          node.textContent =
            pad(Math.floor(s / 3600)) + ' : ' +
            pad(Math.floor(s / 60) % 60) + ' : ' +
            pad(s % 60);
        } else {
          node.textContent =
            pad(Math.floor(s / 86400)) + 'j : ' +
            pad(Math.floor(s / 3600) % 24) + 'h : ' +
            pad(Math.floor(s / 60) % 60) + 'm : ' +
            pad(s % 60) + 's';
        }
      });
    }
    tick();
    countdownTimer = setInterval(tick, 1000);
  }

  /* ---------- Carrousel horizontal ---------- */
  on(document, 'click', '[data-scroll-target]', function (e, el) {
    var track = document.getElementById(el.getAttribute('data-scroll-target'));
    if (!track) return;
    var dir = parseInt(el.getAttribute('data-scroll-dir') || '1', 10);
    track.scrollBy({ left: dir * Math.min(track.clientWidth, 404), behavior: 'smooth' });
  });

  /* ---------- Galerie produit ---------- */
  on(document, 'click', '[data-gallery-thumb]', function (e, el) {
    var wrap = el.closest('[data-gallery]');
    if (!wrap) return;
    var main = wrap.querySelector('[data-gallery-main] img');
    var src = el.getAttribute('data-src');
    if (main && src) {
      main.setAttribute('src', src);
      main.removeAttribute('srcset');
      main.setAttribute('alt', el.getAttribute('data-alt') || '');
    }
    wrap.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t === el ? 'true' : 'false');
    });
  });

  /* ---------- Coloris + formules : résolution de la variante ---------- */
  function productData() {
    var node = document.querySelector('[data-variant-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (err) { return null; }
  }

  function selectedOptions(form) {
    var values = [];
    form.querySelectorAll('[data-swatch="main"][aria-checked="true"]').forEach(function (sw) {
      values[parseInt(sw.getAttribute('data-option-position'), 10) - 1] = sw.getAttribute('data-value');
    });
    form.querySelectorAll('[data-option-select]').forEach(function (sel) {
      values[parseInt(sel.getAttribute('data-option-position'), 10) - 1] = sel.value;
    });
    var offer = form.querySelector('[data-offer][aria-checked="true"]');
    if (offer) {
      var plan = offer.getAttribute('data-plan-value');
      var planPos = form.getAttribute('data-plan-position');
      if (plan && planPos) values[parseInt(planPos, 10) - 1] = plan;
    }
    return values;
  }

  function matchVariant(data, values) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (values[j] != null && v.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function updateProductForm(form) {
    var data = productData();
    if (!data) return;

    var offer = form.querySelector('[data-offer][aria-checked="true"]');
    var external = offer && offer.getAttribute('data-external-product') === 'true';

    var variant = null;
    var priceLabel = '';
    var compareLabel = '';
    var available = true;

    if (external) {
      var idInput = form.querySelector('[data-variant-id]');
      if (idInput) idInput.value = offer.getAttribute('data-external-variant');
      var priceNode = offer.querySelector('[data-offer-price]');
      if (priceNode) {
        var strike = priceNode.querySelector('s');
        compareLabel = strike ? strike.textContent.trim() : '';
        priceLabel = priceNode.textContent.replace(compareLabel, '').trim();
      }
    } else {
      variant = matchVariant(data, selectedOptions(form));
      if (variant) {
        var input = form.querySelector('[data-variant-id]');
        if (input) input.value = variant.id;
        priceLabel = variant.price_label;
        compareLabel = variant.compare_at_price > variant.price ? variant.compare_label : '';
        available = variant.available;
      } else {
        available = false;
      }
      // Prix saisi à la main sur la formule : il prime sur celui de la variante
      if (offer) {
        var manual = offer.querySelector('[data-offer-price]');
        if (manual && offer.getAttribute('data-price-manual') === 'true') {
          var s2 = manual.querySelector('s');
          compareLabel = s2 ? s2.textContent.trim() : '';
          priceLabel = manual.textContent.replace(compareLabel, '').trim();
        }
      }
    }

    var cta = form.querySelector('[data-cta-label]');
    if (cta) {
      if (!available) {
        cta.textContent = data.soldOutLabel;
      } else {
        cta.innerHTML = '';
        cta.appendChild(document.createTextNode(data.buttonLabel + ' — ' + priceLabel + ' '));
        if (compareLabel) {
          var s = document.createElement('s');
          s.textContent = compareLabel;
          cta.appendChild(s);
        }
      }
    }

    var submit = form.querySelector('[type="submit"]');
    if (submit) {
      submit.disabled = !available;
      submit.setAttribute('aria-disabled', available ? 'false' : 'true');
    }

    var qty = form.querySelector('input[name="quantity"]');
    if (qty && offer && !external) {
      qty.value = parseInt(offer.getAttribute('data-quantity') || '1', 10);
    }

    var second = form.querySelector('[data-second-color]');
    if (second) {
      var isDuo = offer && offer.getAttribute('data-duo') === 'true';
      second.hidden = !isDuo;
      second.querySelectorAll('input[name^="properties"]').forEach(function (inp) {
        inp.disabled = !isDuo;
      });
    }

    var sticky = document.querySelector('[data-sticky-price]');
    if (sticky && priceLabel) sticky.textContent = priceLabel;
  }

  on(document, 'click', '[data-offer]', function (e, el) {
    var form = el.closest('[data-product-form]');
    if (!form) return;
    form.querySelectorAll('[data-offer]').forEach(function (o) {
      o.setAttribute('aria-checked', o === el ? 'true' : 'false');
    });
    updateProductForm(form);
  });

  on(document, 'click', '[data-swatch]', function (e, el) {
    var group = el.closest('[data-swatch-group]');
    var form = el.closest('[data-product-form]');
    if (!group) return;
    group.querySelectorAll('[data-swatch]').forEach(function (s) {
      s.setAttribute('aria-checked', s === el ? 'true' : 'false');
    });
    var role = el.getAttribute('data-swatch');
    var label = group.querySelector('[data-swatch-current="' + role + '"]');
    if (label) label.textContent = el.getAttribute('data-value');
    var hidden = group.querySelector('[data-swatch-input="second"]');
    if (hidden) hidden.value = el.getAttribute('data-value');
    if (form && role === 'main') updateProductForm(form);
  });

  on(document, 'change', '[data-option-select]', function (e, el) {
    var form = el.closest('[data-product-form]');
    if (form) updateProductForm(form);
  });

  function initProductForms() {
    document.querySelectorAll('[data-product-form]').forEach(function (form) {
      updateProductForm(form);
    });
  }

  /* ---------- Quantité ---------- */
  on(document, 'click', '[data-qty-step]', function (e, el) {
    var wrap = el.closest('[data-qty]');
    if (!wrap) return;
    var input = wrap.querySelector('input');
    var step = parseInt(el.getAttribute('data-qty-step'), 10);
    var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Tiroir panier ---------- */
  var drawer = null;
  function getDrawer() {
    if (!drawer) drawer = document.getElementById('sielo-cart-drawer');
    return drawer;
  }
  function openDrawer() {
    var d = getDrawer();
    if (!d) { window.location.href = routes.cart || '/cart'; return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var close = d.querySelector('[data-cart-close]');
    if (close) close.focus();
  }
  function closeDrawer() {
    var d = getDrawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  on(document, 'click', '[data-cart-open]', function (e) { e.preventDefault(); refreshCart().then(openDrawer); });
  on(document, 'click', '[data-cart-close]', function (e) { e.preventDefault(); closeDrawer(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  function refreshCart() {
    var url = (routes.cart || '/cart') + '?section_id=cart-drawer';
    return fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById('sielo-cart-drawer');
        var current = getDrawer();
        if (fresh && current) {
          var wasOpen = current.classList.contains('is-open');
          current.innerHTML = fresh.innerHTML;
          if (wasOpen) current.classList.add('is-open');
        }
        return fetch((routes.cart || '/cart') + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
        return cart;
      })
      .catch(function () { return null; });
  }
  window.SieloRefreshCart = refreshCart;

  /* ---------- Ajout au panier en AJAX ---------- */
  on(document, 'submit', 'form[data-ajax-cart]', function (e, form) {
    e.preventDefault();
    var submit = form.querySelector('[type="submit"]');
    var previous = submit ? submit.textContent : '';
    if (submit) { submit.disabled = true; submit.textContent = '…'; }
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(serialize(form))
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) throw new Error(data.description || data.message);
        return refreshCart().then(openDrawer);
      })
      .catch(function (err) {
        var box = form.querySelector('[data-form-error]');
        if (box) { box.hidden = false; box.textContent = err.message; }
        else window.location.href = routes.cart || '/cart';
      })
      .finally(function () {
        if (submit) { submit.disabled = false; submit.textContent = previous; }
      });
  });

  function serialize(form) {
    var data = new FormData(form);
    var payload = { items: [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }] };
    var props = {};
    data.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m && value) props[m[1]] = value;
    });
    if (Object.keys(props).length) payload.items[0].properties = props;
    if (data.get('selling_plan')) payload.items[0].selling_plan = data.get('selling_plan');
    return payload;
  }

  /* ---------- Modification des lignes du panier ---------- */
  on(document, 'click', '[data-line-change]', function (e, el) {
    e.preventDefault();
    var line = el.getAttribute('data-line');
    var quantity = parseInt(el.getAttribute('data-line-change'), 10);
    changeLine(line, quantity);
  });
  function changeLine(line, quantity) {
    fetch((routes.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) window.location.reload();
        else refreshCart();
      });
  }

  /* ---------- Code promo ---------- */
  on(document, 'click', '[data-coupon-apply]', function (e) {
    e.preventDefault();
    var input = document.querySelector('[data-coupon-input]');
    if (!input) return;
    var code = input.value.trim();
    if (!code) { input.focus(); return; }
    window.location.href =
      '/discount/' + encodeURIComponent(code) +
      '?redirect=' + encodeURIComponent(routes.cart || '/cart');
  });

  /* ---------- Ajouts rapides (ventes complémentaires) ---------- */
  on(document, 'click', '[data-quick-add]', function (e, el) {
    e.preventDefault();
    var id = el.getAttribute('data-quick-add');
    el.disabled = true;
    fetch((routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .finally(function () { el.disabled = false; });
  });

  /* ---------- Barre d'achat collante ---------- */
  function stickyBar() {
    var bar = document.querySelector('[data-sticky-bar]');
    var anchor = document.querySelector('[data-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* ---------- Init ---------- */
  function init() {
    startCountdowns();
    stickyBar();
    initProductForms();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);

  window.SieloMoney = money;
})();
